<template>
  <div>
    <div class="bg-root px-5">
      <h3 class="text-root-2 font-bold mb-3 mt-4">Commission</h3>

      <el-form
        label-position="top"
        :model="commissionForm"
        :rules="rules"
        ref="commissionForm"
        label-width="80px"
        size="normal"
      >
        <el-form-item label="Commission Amount" prop="commissionAmount">
          <el-input
            v-model="commissionForm.commissionAmount"
            placeholder="₦0.00"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <o-button
            class="text-center w-full px-6 rounded-3xl bg-primary text-white outline-none border-none mt-2"
            @click="saveCommissionHandler('commissionForm')"
            >Save Commission</o-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { FormatAmount } from '@/utils/helpers'
import country from '@/mixins/getCountryDetails.js'

export default {
  mixins: [country],
  data () {
    return {
      showVerifyAuthDialog: false,
      status: 'Saved',
      authState: 'commissionSettings',
      commissionForm: {
        commissionType: 'Fixed Price',
        commissionAmount: '₦0'
      },
      rules: {
        commissionAmount: [
          {
            required: true,
            message: 'Please enter a commission amount',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    }
  },
  methods: {
    saveCommissionHandler (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('closePartnerCommissionDialog')
          const amount = FormatAmount(this.commissionForm.commissionAmount)
          const details = {
            partnerCommission: amount
          }
          this.$store.dispatch('terminal/setTransferDetails', details)
          this.$notify.success({
            title: 'Settings Saved Successfully',
            message: 'New Commission Amount Saved',
            position: 'top-right'
          })
          this.$emit('closeDialog', amount || 0)
        } else {
          this.$notify.error({
            title: 'Invalid Amount',
            message: 'please input a valid amount',
            position: 'top-right'
          })
        }
      })
    },
    closeDialog () {
      this.showVerifyAuthDialog = false
    }
  },
  watch: {
    'commissionForm.commissionAmount': function (newValue) {
      const result = newValue
        .toString()
        .split('.')[0]
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        .replace(/^0+/g, '')
      this.$nextTick(() => {
        this.commissionForm.commissionAmount = newValue.toString().split('.')[1]
          ? ` ${this.country.symbol}${result}.${
              newValue.toString().split('.')[1]
            }`
          : `${this.country.symbol}${result}`
      })
    },
    deep: true
  },
  beforeMount () {
    this.commissionForm.commissionAmount =
      this.transferDetails.partnerCommission || `${this.country.symbol}0`
  }
}
</script>

<style scoped>
>>> .el-input__inner {
  background-color: var(--background);
  color: var(--text-1) !important;
  height: 50px;
  font-size: 14px;
  border: 1px solid var(--text-3) !important;
}
>>> .el-select {
  padding: 0;
}
>>> .el-popover {
  background: black;
  color: white;
  font-size: 10px;
}
</style>
